var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{staticClass:"inputdate",attrs:{"valueType":"format","disabled":_vm.disabled},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }